import { IGuardPermissions } from '@portal/shared/auth/authorization/src/lib/interfaces/guard-permissions.interface';
import { RouteName } from './route-name.enum';
import { UserRoles } from '@portal/shared/auth/authorization/src/lib/enums/user-roles.enum';

export const routePermissions: { [key in RouteName]?: IGuardPermissions } = {
  [RouteName.List]: {
    read: [UserRoles.MerchantAdmin, UserRoles.VerifoneAdmin],
  },
  [RouteName.Detail]: {
    read: [UserRoles.MerchantAdmin, UserRoles.VerifoneAdmin, UserRoles.EstateOwnerAdmin],
  },
};
